import { render, staticRenderFns } from "./iconList.vue?vue&type=template&id=4af04cc6&scoped=true&"
import script from "./iconList.vue?vue&type=script&lang=js&"
export * from "./iconList.vue?vue&type=script&lang=js&"
import style0 from "./iconList.vue?vue&type=style&index=0&id=4af04cc6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af04cc6",
  null
  
)

export default component.exports